export default function Feature() {
  return (
    <section id="today" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="eyebrow text-xs font-semibold text-primary-700">01 / 今日特稿</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一份可以被复核的档案
            </h2>
          </div>
          <a
            href="#pack"
            className="hidden whitespace-nowrap items-center gap-2 text-sm text-primary-700 hover:text-primary-800 md:inline-flex"
          >
            查看本周整理 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="relative w-full overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20magazine%20photo%20of%20a%20desk%20covered%20with%20printed%20chat%20conversation%20screenshots%2C%20smartphone%20in%20center%20showing%20messaging%20app%2C%20warm%20desk%20lamp%20lighting%2C%20cream%20and%20ink%20tones%2C%20paper%20documents%20with%20red%20marker%20notes%2C%20cinematic%20close%20up%2C%20journalistic%20reportage%20style%2C%20soft%20shadows&width=1280&height=720&seq=ev-feature-01&orientation=landscape"
                alt="国产黑料聊天记录桌面实景特稿"
                className="h-[300px] w-full object-cover md:h-[400px]"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-3 py-1.5 text-xs font-medium text-background-50">
                <i className="ri-focus-3-line" /> 实锤截图 · 复核中
              </span>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-5 md:p-7">
                <span className="text-xs text-accent-300">档案 C-0908</span>
                <h3 className="mt-2 max-w-2xl font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                  跨平台聊天记录首次做到按分钟对齐，顺序不再靠猜
                </h3>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-4">
            <p className="text-sm leading-7 text-foreground-700 md:text-[15px]">
              过去一周，我们把散落在社交平台、私人群与评论区里的碎片证据收进同一张时间线。国产黑料实锤截图、聊天记录与录音视频，如今都能找到对应的落点。
            </p>
            <ul className="flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex gap-3 rounded-lg bg-background-100 p-4">
                <i className="ri-time-line mt-0.5 text-primary-600" />
                <div>
                  <p className="font-medium text-foreground-900">统一北京时间，误差压到分钟级</p>
                  <p className="mt-1 text-xs leading-5 text-foreground-500">每张实锤截图都附来源与采集时刻，杜绝「记不清了」。</p>
                </div>
              </li>
              <li className="flex gap-3 rounded-lg bg-background-100 p-4">
                <i className="ri-folder-check-line mt-0.5 text-primary-600" />
                <div>
                  <p className="font-medium text-foreground-900">逐条标注推断与实锤</p>
                  <p className="mt-1 text-xs leading-5 text-foreground-500">能坐实的用红章，仅推测的单独划线，不给误读留空间。</p>
                </div>
              </li>
              <li className="flex gap-3 rounded-lg bg-background-100 p-4">
                <i className="ri-link-m mt-0.5 text-primary-600" />
                <div>
                  <p className="font-medium text-foreground-900">一键打包，离线复核</p>
                  <p className="mt-1 text-xs leading-5 text-foreground-500">本周整理已导出为可打印的 PDF，方便逐页翻看。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}